import { apiRequest } from './apiClient';

export async function getStudentGrades() {
  const response = await apiRequest('/student/grades');

  return response.data || [];
}

export async function getReportCards() {
  const response = await apiRequest('/student/report-cards');

  return response.data || [];
}

export async function getReportCardById(reportCardId) {
  const response = await apiRequest(`/student/report-cards/${reportCardId}`);

  return response.data || null;
}
